import { render } from "./tarif.vue?vue&type=template&id=9ab8c9f8&scoped=true"
import script from "./tarif.vue?vue&type=script&lang=js"
export * from "./tarif.vue?vue&type=script&lang=js"

import "./tarif.vue?vue&type=style&index=0&id=9ab8c9f8&scoped=true&lang=scss"

import exportComponent from "/Users/ramazansapar/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ab8c9f8"]])

export default __exports__